export default __webpack_public_path__ + "static/media/professional-consulting.800750b1.svg";